import type { DecorateParams, TBannersList } from '../types/advertising';

export const decorateBanners = (banners: TBannersList, params: DecorateParams): TBannersList =>
  Object.entries(banners).reduce(
    (acc, [key, banner]) => ({
      ...acc,
      [key]: {
        ...banner,
        params: {
          ...banner.params,
          ...params,
        },
      },
    }),
    {} as TBannersList,
  );
